import { render } from "./ProductBrandCreateComponent.vue?vue&type=template&id=a708ee3a"
import script from "./ProductBrandCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductBrandCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductBrand/ProductBrandCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a708ee3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a708ee3a', __exports__)) {
    api.reload('a708ee3a', __exports__)
  }
  
  module.hot.accept("./ProductBrandCreateComponent.vue?vue&type=template&id=a708ee3a", () => {
    api.rerender('a708ee3a', render)
  })

}


export default __exports__